import api from './api';

const abonnementService = {
  getAll: () => api.get('/abonnements'),
  getOne: (id) => api.get(`/abonnements/${id}`),
  getAlertes: () => api.get('/abonnements/alertes'),
  create: (data) => api.post('/abonnements', data),
  update: (id, data) => api.put(`/abonnements/${id}`, data),
  remove: (id) => api.delete(`/abonnements/${id}`),
  updateEcheance: (id, data) => api.patch(`/abonnements/echeances/${id}`, data),
};

export default abonnementService;
